  import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../index.css";

import Select from "react-select";
import { AlignLeft, Search } from "lucide-react";
import config from "./config";
import { getProfileFromToken } from "./config";
import MHeader from "./header";
import MAdmin from "./menuadmin";
import Mfooter from "./footer";
function LandingPage({ user, setUSer, bearer, setBearer }) {

  const [optionsN, setOptionsn] = useState([]);
  //const [bearer1, setBearer] = useState({bearer});
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("");
  const [matricola, setMatricola] = useState(null);
  const [testolibero, setTestoLibero] = useState(null);
  const [details, setDetails] = useState(null); // Dati di dettaglio
  const [photo, setPhoto] = useState(null); // Dati di dettaglio
  const [selectedPickOption, setSelectedPickOption] = useState("")
  const [puntoApprossimato, setPuntoApprossimato] = useState("")


  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    console.log("Effetto eseguito");
    // logica da eseguire

  }, [refreshTrigger]); // si riesegue quando refreshTrigger cambia



  



  let profile = getProfileFromToken();

  useEffect(() => {
    if (profile === null || profile==="")
      navigate("/login")
  },[profile]);

  
    return (
      <div className="App">
        <h2 className="App-header">{config.appName}</h2>
        <MHeader />
        <p><small>utente: {user}</small></p>
        <div className="relative" align="center">
          <MAdmin bearer={bearer}/>
       
        </div>
        <Mfooter />
        
      </div>

    )
  
}

export default LandingPage;